// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar.css */

.navbar {
    position: fixed;
    top: 0;
    width: 100%;
    height: max(10%, 60px);
    background-color: #333;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    z-index: 1000;
    box-sizing: border-box; /* Ensures padding is included in width calculations */
  }
  
  .navbar-left h1 {
    margin: 0;
    font-size: 1.8rem;
    font-size: max(1.4rem, 1.8vw);
    white-space: nowrap;
  }

  .navbar-title-link {
    text-decoration: none;
    color: white;
    cursor: pointer;
  }
  
  .navbar-title-link h1 {
    margin: 0;
    font-size: 1.8rem;
    font-size: max(1.4rem, 1.8vw);
    white-space: nowrap;
  }
  
  
  .navbar-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  
  .navbar-right ul {
    list-style: none;
    display: flex;
    gap: 10px;
    margin: 0;
    padding: 0;
    font-size: 1.2rem;
    overflow: hidden; /* Ensures items don't overflow */
  }

  
  .navbar-right ul li{
    cursor: pointer;
    transition: color 0.3s ease;
    white-space: nowrap; /* Prevents text from wrapping */
    padding: 5px 10px;
    
  }

  .navbar-right ul li a {
    text-decoration: none;
    color: white;
    padding: 20px 0;
  }
  
  .navbar-right ul li:hover {
    color: #ddd;
  }
  
  .register-button {
    margin-left: 20px;
    margin-right: 20px;
    padding: 10px 20px;
    font-size: 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    text-decoration: none;
  }
  
  .register-button:hover {
    background-color: #45a049;
  }


.menu-toggle {
  display: none;
  background-color: transparent;
  border: none;
  color: white;
  font-size: 28px;
  cursor: pointer;
  margin-left: 10px;
  padding: 5px 10px;
  z-index: 1001;
}

@media (max-width: 1000px) {
  .navbar-right {
    display: none; /* Hide the menu by default on smaller screens */
    position: fixed;
    right: 20px;
    top: 70px;
    background-color: #333;
    border-radius: 5px;
    width: 200px;
    min-width: 180px;
    flex-direction: column;
    padding: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
    z-index: 1002;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
  }

  .navbar-right.open {
    display: flex; /* Show the menu when open */
  }

  .navbar-right ul {
    flex-direction: column;
    gap: 5px;
    width: 100%;
  }

  .navbar-right ul li {
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .navbar-right ul li:last-child {
    border-bottom: none;
  }

  .navbar-right ul li a {
    display: block;
    padding: 10px 0;
    width: 100%;
  }

  .menu-toggle {
    display: block; /* Show the menu toggle button */
  }

  .navbar-left {
    flex: 1 1;
    min-width: 0;
  }

  .navbar-left h1 {
    font-size: max(1rem, 4vw);
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (max-width: 500px) {
  .navbar {
    padding: 10px 15px;
  }

  .navbar-left h1 {
    font-size: 4vw;
  }

  .navbar-right {
    right: 10px;
    width: 180px;
    min-width: 160px;
  }

  .menu-toggle {
    font-size: 24px;
    padding: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;IACI,eAAe;IACf,MAAM;IACN,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB,EAAE,sDAAsD;EAChF;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;EACrB;;;EAGA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,gBAAgB,EAAE,iCAAiC;EACrD;;;EAGA;IACE,eAAe;IACf,2BAA2B;IAC3B,mBAAmB,EAAE,gCAAgC;IACrD,iBAAiB;;EAEnB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;;AAGF;EACE,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE;IACE,aAAa,EAAE,gDAAgD;IAC/D,eAAe;IACf,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,wCAAwC;IACxC,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,aAAa,EAAE,4BAA4B;EAC7C;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc,EAAE,gCAAgC;EAClD;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* Navbar.css */\n\n.navbar {\n    position: fixed;\n    top: 0;\n    width: 100%;\n    height: max(10%, 60px);\n    background-color: #333;\n    color: white;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 20px;\n    z-index: 1000;\n    box-sizing: border-box; /* Ensures padding is included in width calculations */\n  }\n  \n  .navbar-left h1 {\n    margin: 0;\n    font-size: 1.8rem;\n    font-size: max(1.4rem, 1.8vw);\n    white-space: nowrap;\n  }\n\n  .navbar-title-link {\n    text-decoration: none;\n    color: white;\n    cursor: pointer;\n  }\n  \n  .navbar-title-link h1 {\n    margin: 0;\n    font-size: 1.8rem;\n    font-size: max(1.4rem, 1.8vw);\n    white-space: nowrap;\n  }\n  \n  \n  .navbar-right {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n  \n  .navbar-right ul {\n    list-style: none;\n    display: flex;\n    gap: 10px;\n    margin: 0;\n    padding: 0;\n    font-size: 1.2rem;\n    overflow: hidden; /* Ensures items don't overflow */\n  }\n\n  \n  .navbar-right ul li{\n    cursor: pointer;\n    transition: color 0.3s ease;\n    white-space: nowrap; /* Prevents text from wrapping */\n    padding: 5px 10px;\n    \n  }\n\n  .navbar-right ul li a {\n    text-decoration: none;\n    color: white;\n    padding: 20px 0;\n  }\n  \n  .navbar-right ul li:hover {\n    color: #ddd;\n  }\n  \n  .register-button {\n    margin-left: 20px;\n    margin-right: 20px;\n    padding: 10px 20px;\n    font-size: 16px;\n    background-color: #4CAF50;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    text-decoration: none;\n  }\n  \n  .register-button:hover {\n    background-color: #45a049;\n  }\n\n\n.menu-toggle {\n  display: none;\n  background-color: transparent;\n  border: none;\n  color: white;\n  font-size: 28px;\n  cursor: pointer;\n  margin-left: 10px;\n  padding: 5px 10px;\n  z-index: 1001;\n}\n\n@media (max-width: 1000px) {\n  .navbar-right {\n    display: none; /* Hide the menu by default on smaller screens */\n    position: fixed;\n    right: 20px;\n    top: 70px;\n    background-color: #333;\n    border-radius: 5px;\n    width: 200px;\n    min-width: 180px;\n    flex-direction: column;\n    padding: 15px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n    z-index: 1002;\n    max-height: calc(100vh - 80px);\n    overflow-y: auto;\n  }\n\n  .navbar-right.open {\n    display: flex; /* Show the menu when open */\n  }\n\n  .navbar-right ul {\n    flex-direction: column;\n    gap: 5px;\n    width: 100%;\n  }\n\n  .navbar-right ul li {\n    width: 100%;\n    padding: 10px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  .navbar-right ul li:last-child {\n    border-bottom: none;\n  }\n\n  .navbar-right ul li a {\n    display: block;\n    padding: 10px 0;\n    width: 100%;\n  }\n\n  .menu-toggle {\n    display: block; /* Show the menu toggle button */\n  }\n\n  .navbar-left {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .navbar-left h1 {\n    font-size: max(1rem, 4vw);\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n@media (max-width: 500px) {\n  .navbar {\n    padding: 10px 15px;\n  }\n\n  .navbar-left h1 {\n    font-size: 4vw;\n  }\n\n  .navbar-right {\n    right: 10px;\n    width: 180px;\n    min-width: 160px;\n  }\n\n  .menu-toggle {\n    font-size: 24px;\n    padding: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
